import React from "react";
import { Link } from "react-router-dom";
import { HandHeart } from "lucide-react";

const StickyCTAs = () => null;

export default StickyCTAs;
